<template>
  <div class="print-results">
    <el-table class="table-striped wrap-whole-words" id="taskSearchResults"
              :data="tableData"
              border>
      <el-table-column v-for="column in tableColumns"
                       :key="column.label"
                       :min-width="column.minWidth"
                       :prop="column.prop"
                       :sortable="column.sortable"
                       :label="column.label">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { Table, TableColumn } from 'element-ui'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      Table,
      TableColumn
    },
    computed: {
      ...mapGetters({
        tableData: 'tasks/search/results'
      })
    },
    data() {
      return {
        tableColumns: [
          {
            prop: '_source.name',
            label: 'Name',
            minWidth: 110,
            sortable: true
          },
          {
            prop: '_source.assignee',
            label: 'Assignee',
            minWidth: 140,
            sortable: true
          },
          {
            prop: '_source.dueDate',
            label: 'Due Date',
            minWidth: 150,
            sortable: true
          },
          {
            prop: '_source.status',
            label: 'Status',
            minWidth: 120,
            sortable: true
          },
          {
            prop: '_source.priority',
            label: 'Task Priority',
            minWidth: 180,
            sortable: true
          },
          {
            prop: '_source.project.name',
            label: 'Project Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: '_source.project.address.streetNumber',
            label: 'Street Number',
            minWidth: 190,
            sortable: true
          },
          {
            prop: '_source.project.address.streetName',
            label: 'Street Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: '_source.project.address.city',
            label: 'City',
            minWidth: 180,
            sortable: true
          },
          {
            prop: '_source.job.name',
            label: 'Job Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: '_source.job.builder.name',
            label: 'Builder Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: '_source.job.client.name',
            label: 'Client Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: '_source.job.priority',
            label: 'Job Priority',
            minWidth: 180,
            sortable: true
          }
        ]
      }
    }
  }
</script>

<style scoped>
</style>
